(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-rotator"] && !Shopify.designMode) return;
  try {
    
  class KalAnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.msgs = Array.from(this.querySelectorAll('.kal-announcement__msg'));
      this.interval = parseInt(this.dataset.interval, 10) || 3200;
      this.idx = 0;
      if (this.msgs.length <= 1) return;

      // WCAG 2.2.2: content that moves automatically for more than five
      // seconds needs a way to stop it — hence the pause bindings below.
      //
      // Reduced-motion still rotates, it just does not animate: the CSS in
      // this section drops the fade, leaving a plain text swap. Stopping the
      // rotation outright would strand messages two and three, which carry
      // `hidden` and so become unreachable — and anyone with Reduce Motion
      // enabled on their phone would simply never see them.
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.start();

      // Hover-pause only where a real pointer exists. Touch browsers emulate
      // mouseenter on tap and frequently never fire the matching mouseleave,
      // which left the rotator stopped for good on a phone after any tap near
      // it. Focus pause is bound either way, for keyboards.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
      }
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      if (this.timer) return;
      this.timer = setInterval(this.next.bind(this), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const prev = this.msgs[this.idx];
      prev.classList.remove('is-active');
      prev.setAttribute('hidden', '');

      this.idx = (this.idx + 1) % this.msgs.length;

      const cur = this.msgs[this.idx];
      cur.removeAttribute('hidden');
      // retrigger the fadeUp animation
      cur.classList.remove('is-active');
      void cur.offsetWidth;
      cur.classList.add('is-active');
    }
  }

  if (!customElements.get('kal-announcement-rotator')) {
    customElements.define('kal-announcement-rotator', KalAnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers-grid"] && !Shopify.designMode) return;
  try {
    
  // Same tab behavior as sections/product-tabs.liquid. Anonymous class +
  // customElements guard so whichever section's bundle runs first defines
  // <kal-tabs> exactly once.
  if (!customElements.get('kal-tabs')) {
    customElements.define(
      'kal-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('.kal-tabs__tab'));
          this.panels = Array.from(this.querySelectorAll('.kal-tabs__panel'));
          this.tabs.forEach((t) => t.addEventListener('click', () => this.activate(t.dataset.tab)));
        }
        activate(i) {
          this.tabs.forEach((t) => {
            const on = t.dataset.tab === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          this.panels.forEach((p) => p.classList.toggle('is-hidden', p.dataset.panel !== i));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-video"] && !Shopify.designMode) return;
  try {
    
  class KalVideoFacade extends HTMLElement {
    connectedCallback() {
      this.facade = this.querySelector('.kal-bv__facade');
      this.video = this.querySelector('.kal-bv__video');
      if (this.facade) this.facade.addEventListener('click', this.play.bind(this));
    }
    play() {
      if (this.video) {
        this.classList.add('is-playing');
        this.facade.style.display = 'none';
        try { this.video.play(); } catch (e) {}
      } else if (this.dataset.embed) {
        const iframe = document.createElement('iframe');
        iframe.src = this.dataset.embed;
        iframe.className = 'kal-bv__iframe';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        this.facade.style.display = 'none';
        this.appendChild(iframe);
      }
    }
  }
  if (!customElements.get('kal-video-facade')) customElements.define('kal-video-facade', KalVideoFacade);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kalessie-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  class KalTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-kal-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-kal-panel]'));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.kalTab)));
    }
    select(name) {
      this.tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.kalTab === name)));
      this.panels.forEach((p) => { p.hidden = p.dataset.kalPanel !== name; });
    }
  }
  if (!customElements.get('kal-tabs')) customElements.define('kal-tabs', KalTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-atc"] && !Shopify.designMode) return;
  try {
    
    class KalStickyAtc extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.kal-satc__btn');
        this.priceEl = this.querySelector('.kal-satc__price');
        this.atc = document.querySelector('[id^="ProductSubmitButton-"]');
        if (!this.atc || !this.btn) return;

        this.btn.addEventListener('click', () => { if (!this.btn.disabled) this.atc.click(); });

        this.io = new IntersectionObserver((entries) => {
          const show = !entries[0].isIntersecting;
          this.classList.toggle('is-visible', show);
          document.body.classList.toggle('kal-has-sticky-atc', show);
        }, { threshold: 0 });
        this.io.observe(this.atc);

        this.priceHost = document.querySelector('[id^="price-"]');
        if (this.priceHost) {
          this.mo = new MutationObserver(() => this.sync());
          this.mo.observe(this.priceHost, { subtree: true, childList: true, characterData: true });
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.atc = document.querySelector('[id^="ProductSubmitButton-"]');
            this.sync();
          });
        }
        this.sync();
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.mo) this.mo.disconnect();
        document.body.classList.remove('kal-has-sticky-atc');
      }
      sync() {
        if (this.atc) this.btn.disabled = !!this.atc.disabled;
        this.btn.textContent = this.btn.disabled
          ? ((window.variantStrings && window.variantStrings.soldOut) || 'Sold out')
          : ((window.variantStrings && window.variantStrings.addToCart) || 'Add to cart');
        const host = this.priceHost || document.querySelector('[id^="price-"]');
        if (host && this.priceEl) {
          const el = host.querySelector('.price-item--sale:not(.hidden)') || host.querySelector('.price-item--regular') || host.querySelector('.price-item');
          if (el) { const t = el.textContent.replace(/\s+/g, ' ').trim(); if (t) this.priceEl.textContent = t; }
        }
      }
    }
    if (!customElements.get('kal-sticky-atc')) customElements.define('kal-sticky-atc', KalStickyAtc);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  class KalTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.kal-tabs__tab'));
      this.panels = Array.from(this.querySelectorAll('.kal-tabs__panel'));
      this.tabs.forEach((t) => t.addEventListener('click', () => this.activate(t.dataset.tab)));
    }
    activate(i) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => p.classList.toggle('is-hidden', p.dataset.panel !== i));
    }
  }
  if (!customElements.get('kal-tabs')) customElements.define('kal-tabs', KalTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-marquee"] && !Shopify.designMode) return;
  try {
    
  class KalReviewScroller extends HTMLElement {
    connectedCallback() {
      this.row = this.querySelector('.kal-reviews__row');
      this.dots = Array.from(this.querySelectorAll('.kal-reviews__dot'));
      if (!this.row || this.dots.length === 0) return;
      this.row.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    }
    onScroll() {
      const cards = this.row.children;
      if (!cards.length) return;
      const step = cards[0].offsetWidth + 12;
      const idx = Math.max(0, Math.min(this.dots.length - 1, Math.round(this.row.scrollLeft / step)));
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }
  }
  if (!customElements.get('kal-review-scroller')) customElements.define('kal-review-scroller', KalReviewScroller);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-video-wall"] && !Shopify.designMode) return;
  try {
    
  class KalVideoWall extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('.kal-svw__modal');
      this.embed = this.querySelector('.kal-svw__embed');
      this.player = this.querySelector('.kal-svw__player');
      this.querySelectorAll('.kal-svw__card').forEach((c) =>
        c.addEventListener('click', () => {
          // A card with its own clip opens that, with sound and controls.
          // Anything else falls back to the post's Instagram embed.
          const src = c.dataset.clipSrc;
          if (src) this.openClip(src, c.dataset.clipType || 'video/mp4', c.dataset.clipPoster || '');
          else this.open(c.dataset.embedUrl);
        })
      );
      this.querySelectorAll('[data-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      this._onKey = (e) => { if (e.key === 'Escape') this.close(); };
      document.addEventListener('keydown', this._onKey);
      this.initPreviews();
      // The auto-pulled cover depends on a public proxy and on the post being
      // public. If either fails, drop the image so the card falls back to its
      // gradient rather than showing a broken-image icon.
      this.querySelectorAll('[data-kal-ig-thumb]').forEach((img) => {
        img.addEventListener('error', () => img.remove(), { once: true });
      });
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKey);
      if (this._io) this._io.disconnect();
    }

    // The tile preview is muted by browser rule; this is the same clip again
    // at full size, unmuted, with controls. Tile previews pause while it runs
    // so two copies of the audio-less loop are not competing for decode.
    openClip(src, type, poster) {
      if (!this.player) return this.open('');
      this.querySelectorAll('.kal-svw__videowrap video').forEach((v) => v.pause());
      this.embed.hidden = true;
      this.player.hidden = false;
      this.player.innerHTML =
        '<video class="kal-svw__playervideo" controls autoplay playsinline preload="auto"' +
        (poster ? ' poster="' + poster + '"' : '') +
        '><source src="' + src + '" type="' + type + '"></video>';
      const v = this.player.querySelector('video');
      v.muted = false;
      v.volume = 1;
      const p = v.play();
      // Some browsers still refuse unmuted autoplay; fall back to muted so the
      // clip runs, and the visible controls let the viewer unmute in one tap.
      if (p && p.catch) p.catch(() => { v.muted = true; v.play().catch(() => {}); });
      this.modal.hidden = false;
      document.body.classList.add('kal-svw-locked');
    }

    // Muted previews play only while the tile is on screen, so a row of clips
    // never downloads or decodes in the background on a phone. preload="none"
    // in the markup means nothing is fetched until that first intersection.
    initPreviews() {
      const videos = Array.from(this.querySelectorAll('.kal-svw__videowrap video'));
      if (!videos.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      this._io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const v = entry.target;
          const card = v.closest('.kal-svw__card');
          if (entry.isIntersecting) {
            v.muted = true;             // required for autoplay to be allowed
            v.playsInline = true;
            const p = v.play();
            if (p && p.catch) p.catch(() => { /* blocked: poster stays */ });
            if (card) card.classList.add('is-previewing');
          } else {
            v.pause();
            if (card) card.classList.remove('is-previewing');
          }
        });
      }, { threshold: 0.35 });

      videos.forEach((v) => {
        v.muted = true;
        v.setAttribute('playsinline', '');
        this._io.observe(v);
      });
    }
    toEmbed(url) {
      if (!url) return '';
      if (url.indexOf('tiktok.com') !== -1) {
        const m = url.match(/video\/(\d+)/);
        return m ? 'https://www.tiktok.com/embed/v2/' + m[1] : url;
      }
      if (url.indexOf('instagram.com') !== -1) {
        let u = url.split('?')[0];
        if (u.charAt(u.length - 1) !== '/') u += '/';
        return u + 'embed';
      }
      return url;
    }
    open(url) {
      const src = this.toEmbed(url);
      if (!src) return;
      if (this.player) this.player.hidden = true;
      this.embed.hidden = false;
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; fullscreen';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('scrolling', 'no');
      this.embed.appendChild(iframe);
      this.modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    close() {
      this.modal.hidden = true;
      this.embed.innerHTML = '';
      // Tearing the <video> out stops its audio immediately; leaving it in the
      // DOM would keep the sound playing behind a hidden modal.
      if (this.player) { this.player.innerHTML = ''; this.player.hidden = true; }
      document.body.classList.remove('kal-svw-locked');
      document.body.style.overflow = '';
      // Let the on-screen tile previews resume.
      if (this._io) {
        this.querySelectorAll('.kal-svw__card.is-previewing .kal-svw__videowrap video')
          .forEach((v) => v.play().catch(() => {}));
      }
    }
  }
  if (!customElements.get('kal-video-wall')) customElements.define('kal-video-wall', KalVideoWall);

  } catch(e) { console.error(e); }
})();
})();
